import tokeys from 'tokeys';

export const Authorize = tokeys(['Always', 'IfLogged', 'Never']);
